import styled from 'styled-components';
import Spinner from 'react-spinners/ClipLoader';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: center;
  width: 100%;
`;

export const InfoRow = styled.div`
  width: 100%;
  display: flex;
`;

export const ToolBar = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
`;

export const Info = styled.p`
  display: flex;
  flex-direction: ${(props) => props.defaultValue};
  gap: 15px;
  font-size: 12px;
  align-items: center;
  color: ${(props) => props.theme.colors.text};
`;

export const BaseTable = styled.table`
  width: 100%;
  border-radius: 5px;
  border-spacing: 0;

  & tr:last-child td:first-child {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  & tr:last-child td:last-child {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  @media (max-width: 975px) {
    & {
      border: none;
    }

    &,
    tbody,
    tr,
    td {
      display: block;
      width: 100%;
    }

    tr {
      border: 1px solid ${(props) => props.theme.colors.lightGray};
      margin-bottom: 15px;

      &:last-child > td {
        border-bottom: 1px solid ${(props) => props.theme.colors.lightGray};
      }
    }

    td {
      padding-left: 50%;
      text-align: right;
      position: relative;
      border-bottom: 1px solid ${(props) => props.theme.colors.lightGray};
    }

    td:before {
      content: attr(data-label);
      position: absolute;
      left: 0;
      width: 50%;
      padding-left: 15px;
      text-align: left;
      font-weight: 700;
    }
  }
`;

export const TableHeader = styled.thead`
  width: 100%;

  @media (max-width: 975px) {
    display: none;
  }
`;

export const FixedHeaderColumn = styled.td`
  padding: 15px;
  font-size: 14px;
  border-bottom: 1px solid ${(props) => props.theme.colors.lightGray};
  background-color: ${(props) => props.theme.colors.softGray};
  font-weight: 500;
  color: ${(props) => props.theme.colors.darkGray};
`;

export const HeaderRow = styled.tr``;

export const TableBody = styled.tbody`
  width: 100%;
`;

export const Row = styled.tr`
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  background-color: ${(props) => props.theme.colors.table.row};

  &:last-child > td {
    border-bottom: none;
  }

  &:hover td {
    transition: all 0.2s ease-in-out;
    background-color: rgba(128, 128, 128, 0.1);
  }
`;

export const EmptyColumn = styled.td.attrs({colSpan: 100})`
  padding: 15px !important;
  text-align: center !important;
  font-size: 12px;
  border-bottom: 1px solid ${(props) => props.theme.colors.lightGray};
  color: ${(props) => props.theme.colors.darkGray};
  font-weight: 600;
`;

export const LoaderContainer = styled.td.attrs({colSpan: 100})`
  padding: 15px !important;
  flex: 1;
  text-align: center !important;
`;

export const Loader = styled(Spinner).attrs((props) => ({
  size: 18,
  color: props.theme.colors.primary,
}))``;

export const PlaceholderHeaderColumn = styled.td`
  background-color: ${(props) => props.theme.colors.softGray};
`;

export const PlaceholderColumn = styled.td`
  padding: 0 5px;
  border-bottom: 1px solid ${(props) => props.theme.colors.lightGray};
`;

export const PlaceholderIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ExpandedRow = styled.tr`
  border-bottom: 1px solid ${(props) => props.theme.colors.lightGray};
`;
